/**
 * Scales a phone photo down before it is uploaded (a straight-from-the-camera photo can be 10 MB), keeping the
 * orientation the phone recorded. The server re-crops and re-encodes it anyway, so this only saves the upload.
 * If anything about it fails, the original file is sent instead.
 */
export async function shrinkImage(file: Blob, maxSide = 1024): Promise<Blob> {
  try {
    const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' })
    const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height))
    const canvas = document.createElement('canvas')
    canvas.width = Math.round(bitmap.width * scale)
    canvas.height = Math.round(bitmap.height * scale)
    canvas.getContext('2d')!.drawImage(bitmap, 0, 0, canvas.width, canvas.height)
    bitmap.close()
    const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.85))
    return blob ?? file
  } catch {
    return file
  }
}
